import APIClient from '@/shared/http/clients/api'

const resourceName = 'usuarios/password'
const APICore = process.env.APIBaseURLCore

const SetPassword = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}`, data, config)

const PasswordRepository = {
  SetPassword
}

export default PasswordRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/password.js